module.exports = __webpack_public_path__ + "img/77.ec687d72.jpg";